import { styled } from "../imports";
import Box from "./Box";
import { sizeProps, overflowProps } from "../props";
import { prop, spaceProp } from "../utils";
var padding = function padding(val, rawVal, p) {
  if (p.x === true && !p.y) return "padding-left:" + val + ";padding-right:" + val + ";";
  if (!p.x && p.y === true) return "padding-top:" + val + ";padding-bottom:" + val + ";";
  if (!p.x && !p.y) return "padding:" + val + ";";
  return "";
};
var Inset = /*#__PURE__*/styled(Box, {
  label: "Inset",
  target: "css-c04di30"
})(sizeProps, ";", overflowProps, ";", spaceProp(padding), ";", prop("x", function (val) {
  return "padding-left:" + val + ";padding-right:" + val;
}), ";", prop("y", function (val) {
  return "padding-top:" + val + ";padding-bottom:" + val;
}), ";");
Inset.displayName = "Inset";
export default Inset;